import { STATUS_OPTIONS } from "../constants/filters";
import i18n from "../../../public/i18n";

//ADMIN

export const labelForDashboard = (k, v, studio, operators, users) => {
  if (k === "studioId")
    for (const s of studio.Data.items) {
      if (s.id === v)
        return (
          i18n.t("Studio") +
          ": " +
          (s.name.length > 18
            ? `${s.name.substring(0, 20)}...`
            : s.name.length === 0
              ? "nessun nome"
              : s.name)
        );
    }
  if (k === "adminId")
    for (const admin of operators.Data.items) {
      if (admin.id === v)
        return `${i18n.t("Operator")}: ${admin.name} ${admin.surname}`;
    }

  if (k === "userId")
    for (const user of users.Data.items) {
      if (user.id === v)
        return `${i18n.t("User")}: ${user.name} ${user.surname}`;
    }
};

export const labelForFilterDoc = (
  k,
  v,
  data,
  studio,
  operators,
  companies,
  practices
) => {
  if (k === "minAmount") return `Importo minimo: ${v}€`;
  if (k === "maxAmount") return `Importo massimo: ${v}€`;
  if (k === "dateTo") return `Anno: ${v.substring(0, 4)}`;
  if (k === "referenceYear") return `Anno riferimento: ${v}`;
  if (k === "status") {
    switch (v) {
      case 3:
        return `${i18n.t("DocsStatus")}: ${i18n.t("toValidate")}`;
      case 6:
        return `${i18n.t("DocsStatus")}: ${i18n.t("discarded")}`;
      default:
        return `${i18n.t("DocsStatus")}: ${i18n.t("validated")}`;
    }
  }
  for (const c of data) {
    if (c.id === v)
      return (
        "Categoria: " +
        (c.name.length > 18 ? `${c.name.substring(0, 20)}...` : c.name)
      );
    for (const s of c.expenseCategories) {
      if (s.id === v)
        return (
          "Sottocategoria: " +
          (s.name.length > 18 ? `${s.name.substring(0, 20)}...` : s.name)
        );
    }
    if (k === "companyId")
      for (const company of companies.Data.items) {
        if (company.id === v)
          return `Azienda: ${company.name.length > 18
            ? `${company.name.substring(0, 20)}...`
            : company.name
            }`;
      }
  }
  if (k === "studioId")
    for (const s of studio.Data.items) {
      if (s.id === v)
        return (
          i18n.t("Studio") +
          ": " +
          (s.name.length > 18
            ? `${s.name.substring(0, 20)}...`
            : s.name.length === 0
              ? "nessun nome"
              : s.name)
        );
    }
  if (k === "adminId")
    for (const admin of operators.Data.items) {
      if (admin.id === v)
        return `${i18n.t("Operator")}: ${admin.name} ${admin.surname}`;
    }
  if (k === "practiceId")
    for (const pract of practices.Data.items) {
      if (pract.id === v) return `${i18n.t("Practice")}: ${pract.name}`;
    }
  if (k === "read") return i18n.t("ImportantDoc");
  return v.length > 20 ? `${v.substring(0, 20)}...` : v;
};

export const labelForFilterArchivieDoc = (
  k,
  v,
  studio,
  operators,
) => {
  if (k === "minAmount") return `Importo minimo: ${v}€`;
  if (k === "maxAmount") return `Importo massimo: ${v}€`;
  if (k === "dateTo") return `Anno: ${v.substring(0, 4)}`;
  if (k === "referenceYear") return `Anno riferimento: ${v}`;
  if (k === "status") {
    switch (v) {
      case 3:
        return `${i18n.t("DocsStatus")}: ${i18n.t("toValidate")}`;
      case 6:
        return `${i18n.t("DocsStatus")}: ${i18n.t("discarded")}`;
      default:
        return `${i18n.t("DocsStatus")}: ${i18n.t("validated")}`;
    }
  }

  if (k === "studioId")
    for (const s of studio.Data.items) {
      if (s.id === v)
        return (
          i18n.t("Studio") +
          ": " +
          (s.name.length > 18
            ? `${s.name.substring(0, 20)}...`
            : s.name.length === 0
              ? "nessun nome"
              : s.name)
        );
    }
  if (k === "adminId")
    for (const admin of operators.Data.items) {
      if (admin.id === v)
        return `${i18n.t("Operator")}: ${admin.name} ${admin.surname}`;
    }
  if (k === "read") return i18n.t("ImportantDoc");
  return v.length > 20 ? `${v.substring(0, 20)}...` : v;
};

export const labelForFilterPractice = (
  k,
  v,
  p,
  studio,
  operators,
  companies
) => {
  if (k === "status") return `Stato: ${v}`;
  if (k === "queryName") return `Nome: ${v}`;
  if (k === "serviceId" && p) {
    for (const c of p.Data.items) {
      if (c.id === v) return `${i18n.t("Service")}: ${c.name}`;
    }
  }
  if (k === "studioId")
    for (const s of studio.Data.items) {
      if (s.id === v)
        return (
          i18n.t("Studio") +
          ": " +
          (s.name.length > 18
            ? `${s.name.substring(0, 20)}...`
            : s.name.length === 0
              ? "nessun nome"
              : s.name)
        );
    }
  if (k === "adminId")
    for (const admin of operators.Data.items) {
      if (admin.id === v)
        return `${i18n.t("Operator")}: ${admin.name} ${admin.surname}`;
    }
  if (k === "companyId")
    for (const company of companies.Data.items) {
      if (company.id === v)
        return `${i18n.t("Company")}: ${company.name.length > 18
          ? `${company.name.substring(0, 20)}...`
          : company.name
          }`;
    }
};

export const labelForFilterOperators = (
  key,
  value,
  roles = [],
  studios = []
) => {
  if (key === "identityRoleId")
    for (const r of roles.Data) {
      if (r.id === value) return `Tipo ${i18n.t("operator")}: ${r.name}`;
    }
  for (const s of studios.Data.items) {
    if (s.id === value)
      return (
        i18n.t("Studio") +
        ": " +
        (s.name.length > 18
          ? `${s.name.substring(0, 20)}...`
          : s.name.length === 0
            ? "nessun nome"
            : s.name)
      );
  }
};

export const labelForFilterCompany = (k, v, services) => {
  if (k === "service")
    for (const s of services.Data.items) {
      if (s.id === v) return i18n.t("Service") + ": " + s.name;
    }
};

export const labelForFilterChat = (key, value, operators, practices) => {
  if (key === "userId") return;
  if (key === "status") {
    switch (value) {
      case 1:
        return `${i18n.t("ChatStatus")}: ${i18n.t("Closed")}`;
      default:
        return `${i18n.t("ChatStatus")}: ${i18n.t("Open")}`;
    }
  }
  if (key === "adminId")
    for (const admin of operators.Data.items) {
      if (admin.id === value)
        return `${i18n.t("Operator")}: ${admin.name} ${admin.surname}`;
    }
  if (key === "practiceId")
    for (const pract of practices.Data.items) {
      if (pract.id === value) return `${i18n.t("Practice")}: ${pract.name}`;
    }
};

//USER

export const labelForFilterPracticeUser = (k, v) => {
  if (k === "status") {
    return `Stato: ${STATUS_OPTIONS.find((stato) => stato.value === v).label}`;
  }
  if (k === "startDate") return `Da: ${v}`;
  if (k === "endDate") return `A: ${v}`;
};

export const labelForFilterDocUser = (k, v, d) => {
  if (k === "minAmount") return `Importo minimo: ${v}€`;
  if (k === "maxAmount") return `Importo massimo: ${v}€`;
  if (k === "dateTo") return `Anno: ${v.substring(0, 4)}`;

  for (const c of d) {
    if (c.id === v)
      return (
        i18n.t("Category") +
        ": " +
        (c.name.length > 18 ? `${c.name.substring(0, 20)}...` : c.name)
      );
    for (const s of c.expenseCategories) {
      if (s.id === v)
        return (
          "Sottocategoria: " +
          (s.name.length > 18 ? `${s.name.substring(0, 20)}...` : s.name)
        );
    }
  }
};

export const labelForFilterStudio = (k, v, operators) => {
  if (k === "adminId")
    for (const admin of operators.Data.items) {
      if (admin.id === v)
        return i18n.t("Operator") + ":" + admin.name + " " + admin.surname;
    }
};

export const labelForFilterGestioneUser = (
  k,
  v,
  docStatus,
  studio,
  companies,
  operators,
  services,
  employments
) => {
  for (const s of docStatus) {
    if (s.value === v) return i18n.t("Documents") + ": " + s.name;
  }
  for (const s of studio.Data.items) {
    if (s.id === v)
      return (
        i18n.t("Studio") +
        ": " +
        (s.name.length > 18 ? `${s.name.substring(0, 20)}...` : s.name)
      );
  }
  if (k === "userCompanyId")
    for (const company of companies.Data.items) {
      if (company.id === v)
        return `${i18n.t("Company")}: ${company.name.length > 18
          ? `${company.name.substring(0, 20)}...`
          : company.name
          }`;
    }
  if (k === "adminId")
    for (const operator of operators.Data.items) {
      if (operator.id === v)
        return `${i18n.t("Operator")}: 
          ${operator.name} ${operator.surname}`;
    }
  if (k === "service")
    for (const serv of services.Data.items) {
      if (serv.id === v)
        return `${i18n.t("Service")}: 
          ${serv.name}`;
    }
  if (k === "employment")
    for (const emp of employments.Data) {
      if (emp.id === v)
        return `Tipo ${i18n.t("user")}: 
          ${emp.name}`;
    }
};
